import React from 'react';
import MenuItem from '@mui/material/MenuItem';
import EditNote from '@mui/icons-material/EditNote';
import BasePersonTimelineRecordLayout from 'domain/shared/timeline/person/PersonTimelineRecord/BasePersonTimelineRecordLayout';
import { useShowContext } from 'framework/show';
import { TimelineType } from 'domain/shared/timeline/layout/BaseTimelineRecordLayout/timelineLayoutHelper';
import { Collapsible, HtmlField } from 'framework/ui/field';
import { ReplaceUrlWithLink } from 'framework/utils';
import { EmployeeLinkFieldWithNameLoading } from 'domain/shared/employee';
import { ShowDate } from 'framework/ui/ui-builder';
import { DATE_FORMAT } from 'framework/utils';
import {
  personTimelineActionNameSx,
  personTimelineDateSx,
  personTimelineHeaderSx,
} from 'domain/shared/timeline/person/PersonTimelineRecord/personTimelineRecordSx';
import { Box } from '@mui/material';

const TIMELINE_ICONS: Record<string, React.ComponentType<any>> = {
  [TimelineType.NOTE]: EditNote,
  default: EditNote,
};

const StaffingNoteTimelineRecordHeader = () => {
  const { data: entity } = useShowContext();
  const author = entity.getValueBySource('author');
  const dateTime = entity.getValueBySource('dateTime');

  return (
    <Box sx={personTimelineHeaderSx}>
      <Box sx={personTimelineActionNameSx}>
        <EmployeeLinkFieldWithNameLoading value={author} />
      </Box>
      <Box sx={personTimelineDateSx}>
        <ShowDate dateUTC={dateTime} format={DATE_FORMAT.FULL} />
      </Box>
    </Box>
  );
};

const StaffingNoteTimelineRecordLayout = (props: any) => {
  const buttons = [
    <MenuItem key="edit" onClick={props.onEdit}>
      Edit note
    </MenuItem>,
  ];

  return (
    <BasePersonTimelineRecordLayout
      actionName=""
      timelineType={TimelineType.NOTE}
      buttons={buttons}
      timelineIcons={TIMELINE_ICONS}
      timelineHeader={StaffingNoteTimelineRecordHeader}
      artifactsSource="attachmentPaths"
      noteTextSource="noteText"
      fields={
        <Collapsible>
          <ReplaceUrlWithLink>
            <HtmlField source="noteText" label="" />
          </ReplaceUrlWithLink>
        </Collapsible>
      }
      permissionToCheck={null}
      isCandidateService={false}
      isStaffingService={true}
      isShowButtons={() => true}
      {...props}
    />
  );
};

export default StaffingNoteTimelineRecordLayout;
